export function formatPhone(input) {
  // Delete every number that is not a digit
  const cleaned = input.replace(/\D/g, '').slice(0, 10); // max 10 digits

  if (cleaned.length <= 3) {
    return cleaned;
  } else if (cleaned.length <= 6) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
  } else {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
}
